import {
  Wrench, Hammer, Grid3x3, Mountain, Boxes, Ruler, Umbrella, Flame, Droplets, ArrowUpRight,
} from "lucide-react";
import { motion } from "framer-motion";
import { SERVICES } from "@/data/content";
import { Reveal, scrollToTarget } from "@/components/site/Reveal";

const ICONS = { Wrench, Hammer, Grid3x3, Mountain, Boxes, Ruler, Umbrella, Flame, Droplets };

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="bg-lightgray py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <Reveal>
          <span className="text-brick font-bold text-sm tracking-[0.18em] uppercase">What We Do</span>
          <div className="mt-3 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <h2 className="font-heading font-extrabold tracking-tight text-charcoal text-4xl sm:text-5xl lg:text-6xl max-w-2xl leading-[1.03]">
              Masonry & chimney services, done right.
            </h2>
            <p className="text-charcoal/60 max-w-md text-base sm:text-lg">
              From a cracked chimney crown to a full stone facade, our craftsmen handle it all with lasting quality.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.id} delay={(i % 3) * 0.08}>
                <motion.div
                  data-testid={`service-card-${s.id}`}
                  whileHover={{ y: -6 }}
                  transition={{ duration: 0.3 }}
                  className="group h-full bg-white rounded-2xl overflow-hidden border border-black/5 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgb(0,0,0,0.12)] transition-shadow duration-300 flex flex-col"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={s.img}
                      alt={s.title}
                      loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4 w-11 h-11 rounded-xl bg-white/95 backdrop-blur flex items-center justify-center shadow-md">
                      <Icon className="w-5 h-5 text-brick" strokeWidth={2} />
                    </div>
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <h3 className="font-heading font-bold text-charcoal text-xl">{s.title}</h3>
                    <p className="mt-2 text-charcoal/60 text-sm leading-relaxed flex-1">{s.desc}</p>
                    <button
                      data-testid={`service-learn-more-${s.id}`}
                      onClick={() => scrollToTarget("#estimate")}
                      className="mt-5 inline-flex items-center gap-1.5 text-brick font-bold text-sm self-start group/btn"
                    >
                      Learn More
                      <ArrowUpRight className="w-4 h-4 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition-transform" />
                    </button>
                  </div>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
